import { useEffect } from 'react';

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'iframe',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/** Éléments atteignables au clavier dans `root` (visibles uniquement). */
export function focusableIn(root) {
  if (!root) return [];
  return Array.from(root.querySelectorAll(FOCUSABLE)).filter(
    (el) => !el.closest('[inert]') && (el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement)
  );
}

// Pièges actifs, du plus ancien au plus récent : seul le dernier (la fenêtre du
// dessus, par exemple la confirmation ouverte depuis le tiroir mobile) réagit à Tab
const trapStack = [];

/**
 * Piège de focus des fenêtres modales (UI-05, UI-18) : Tab et Maj+Tab bouclent
 * dans `ref`. Actif seulement quand `active` est vrai. Plusieurs pièges empilés :
 * seul le plus récent agit.
 */
export function useFocusTrap(ref, active) {
  useEffect(() => {
    if (!active) return undefined;
    const token = {};
    trapStack.push(token);
    const onKeyDown = (event) => {
      if (event.key !== 'Tab' || !ref.current) return;
      if (trapStack[trapStack.length - 1] !== token) return;
      const items = focusableIn(ref.current);
      if (!items.length) {
        event.preventDefault();
        ref.current.focus();
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const current = document.activeElement;
      const inside = ref.current.contains(current);
      if (event.shiftKey && (current === first || !inside)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (current === last || !inside)) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      const index = trapStack.indexOf(token);
      if (index !== -1) trapStack.splice(index, 1);
    };
  }, [ref, active]);
}
